import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert"
import {
  getCurrentUser,
  getPermission,
  sendWhatsAppMessage,
  setCurrentUser,
} from "../../helpers/Utils"
import axios from "axios"
import classnames from "classnames"
import ReminderModal from "../Reminder"
import CcomplaintTable from "../Customer-Profile/C-complaints"
import CschemeTable from "../Customer-Profile/C-scheme"
import CproductTable from "../Customer-Profile/C-product"
import CledgerTable from "../Customer-Profile/C-ledger"
import CQuotationsTable from "../Customer-Profile/C-Quotations"
import CorderTable from "../Customer-Profile/C-order"
import CproformaTable from "../Customer-Profile/C-proforma"
import CupdateTable from "../Customer-Profile/C-update"
import ChistoryTable from "../Customer-Profile/C-history"
import CprofileTable from "../Customer-Profile/C-profile"
import CreateFollowup from "../Create-Followup"
import LongText from "../MessageField"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { usePopperTooltip } from "react-popper-tooltip"
import "react-popper-tooltip/dist/styles.css"
import ClipLoader from "react-spinners/ClipLoader"
import EditLeadModal from "./EditLeadModal"
import MetaWhatsAppSendModal from "./MetaWhatsAppSendModal"
import { useHistory } from "react-router-dom"

let selectedRoleId = []

const LeadList = props => {
  const history = useHistory()
  const [lead, setLead] = useState(props.data)
  const [showInfo, setShowInfo] = useState(false)
  const [modal_standard, setmodal_standard] = useState(false)
  const [modal_standard2, setmodal_standard2] = useState(false)
  const [modal_reminder, setmodal_reminder] = useState(false)
  const [updateTab, setUpdateTab] = useState(false)
  const [historyTab, setHistoryTab] = useState(false)
  const [productTab, setProductTab] = useState(false)
  const [proformaTab, setProformaTab] = useState(false)
  const [orderTab, setOrderTab] = useState(false)
  const [quotationsTab, setQuotationsTab] = useState(false)
  const [ledgerTab, setLedgerTab] = useState(false)
  const [schemeTab, setSchemeTab] = useState(false)
  const [complaintTab, setComplaintTab] = useState(false)
  const [modal_xl, setmodal_xl] = useState(false)
  const [metaWaModal, setMetaWaModal] = useState(false)
  const metaWhatsappEnabled =
    getCurrentUser()?.enable_whatsapp_meta_integration === 1 ||
    getCurrentUser()?.enable_whatsapp_meta_integration === "1"
  const [modal, setModal] = useState(false)
  const [followupActiveTab, setFollowupActiveTab] = useState(2)
  const [customActiveTab, setCustomActiveTab] = useState(2)
  const [check, setCheck] = useState(0)
  const [message_alert, setmessage_alert] = useState(
    props.global && lead.can_edit_lead === null ? true : false
  )
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isOpen2, setIsOpen2] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [typeMature, setTypeMature] = useState(
    lead.type && lead.type.includes("matured") ? true : false
  )
  const [error, setError] = useState("")
  const [profileData, setProfileData] = useState([])
  const [historyData, setHistoryData] = useState([])
  const [loader3, setLoader3] = useState(false)
  const [loader, setLoader] = useState(false)

  // Utility function to update both lead state and localStorage
  const updateLeadAndStorage = updatedLeadData => {
    setLead(updatedLeadData)

    try {
      const existingLeads = JSON.parse(
        localStorage.getItem("LeadsData") || "[]"
      )

      const updatedLeads = existingLeads.map(existingLead => {
        if (existingLead.id === updatedLeadData.id) {
          return { ...existingLead, ...updatedLeadData }
        }
        return existingLead
      })

      const leadExists = existingLeads.some(
        existingLead => existingLead.id === updatedLeadData.id
      )
      if (!leadExists) {
        updatedLeads.push(updatedLeadData)
      }

      localStorage.setItem("LeadsData", JSON.stringify(updatedLeads))
    } catch (error) {
      console.log("Error updating localStorage:", error)
    }
  }

  const getProfileData = e => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead/${e}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${getCurrentUser().token || ""}`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setProfileData(res.data.data)

          updateLeadAndStorage(res.data.data)
        } else {
          setError(res.data.message)
        }
        setLoader(false)
        setmodal_xl(true)
        setUpdateTab(true)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 401) {
            setCurrentUser("")
            localStorage.setItem("DashboardData", "")
            localStorage.setItem("LastUpdated", "")
            localStorage.setItem("NavCounters", "")
            history.push("/login")
          }
        } else if (error.request) {
          console.log("No response received", error.request)
          setCurrentUser("")
          localStorage.setItem("DashboardData", "")
          localStorage.setItem("LastUpdated", "")
          localStorage.setItem("NavCounters", "")
          history.push("/login")
        } else {
          console.log("Error:", error.message)
        }
      })
  }

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab)
    }
    if (tab == 2) {
      setUpdateTab(true)
    }
    if (tab == 3) {
      setHistoryTab(true)
    }
    if (tab == 4) {
      setProductTab(true)
    }
    if (tab == 5) {
      setProformaTab(true)
    }
    if (tab == 6) {
      setOrderTab(true)
    }
    if (tab == 7) {
      setQuotationsTab(true)
    }
    if (tab == 8) {
      setLedgerTab(true)
    }
    if (tab == 9) {
      setSchemeTab(true)
    }
    if (tab == 10) {
      setComplaintTab(true)
    }
  }

  const deleteLead = e => {
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead/${e}?is_deleted=${check}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${getCurrentUser().token || ""}`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLead("")
          setCheck(0)
          props.leadDisplay()
          setdynamic_description(res.data.message)
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
  }

  const editLead = e => {
    if (loader3 === true) {
      setIsOpen(false)
      setmodal_standard(false)
    } else {
      setIsOpen(true)
      setmodal_standard(true)
    }
  }
  useEffect(() => {
    const triggerId = localStorage.getItem("hasRunEditLead")

    if (triggerId && lead.orders.length === 1) {
      editLead()
      localStorage.removeItem("hasRunEditLead")
    }
  }, [lead?.id])

  const editLead2 = e => {
    if (loader3 === true) {
      setIsOpen(false)
      setmodal_standard2(false)
    } else {
      setIsOpen(true)
      setmodal_standard2(true)
    }
  }

  const updateReminder = e => {
    setIsOpen2(true)
    setmodal_reminder(true)
  }

  useEffect(() => {
    selectedRoleId = []
  }, [])

  const getSelectedId = (e, check) => {
    if (check.target.checked) {
      selectedRoleId.push(e)
      const uniqueID = selectedRoleId.filter((val, id, array) => {
        return array.indexOf(val) == id
      })
      selectedRoleId = uniqueID
      props.setLeadsSelectedIds(selectedRoleId)
    } else {
      selectedRoleId = props.leadsSelectedIds
      var array = selectedRoleId
      var index = array.indexOf(e)
      if (index !== -1) {
        array.splice(index, 1)
      }
      props.setLeadsSelectedIds(selectedRoleId)
    }
    if (selectedRoleId.length == 0) {
      props.setBlur(false)
    } else {
      props.setBlur(true)
    }
  }

  useEffect(() => {
    const close = e => {
      if (e.key === "Escape") {
        setmodal_xl(false)
      }
    }
    window.addEventListener("keydown", close)
    return () => window.removeEventListener("keydown", close)
  }, [])

  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({
    placement: "top",
  })

  // Helper functions for rendering optimization
  const isTeamLeaderViewingOtherLead = () =>
    getCurrentUser().role_name === "Team Leader" &&
    getCurrentUser().name !== lead.leadholder_name

  const getCountryCode = () => lead.country_code || "+91"

  const renderContactInfo = (showFullInfo = false) => (
    <>
      <a href={`tel:${getCountryCode()}${lead.number}`}>
        <i className={`fa fa-${showFullInfo ? "mobile" : "phone"}`}></i>{" "}
        {getCountryCode()}{" "}
        {showFullInfo
          ? lead.number
          : isTeamLeaderViewingOtherLead()
          ? "**********"
          : `******${lead.number.substr(-4)}`}
      </a>
      <br />
      {lead.email && (
        <>
          <i className="fa fa-envelope"></i>{" "}
          {showFullInfo ? lead.email : "***********.gmail.com"}
          <br />
        </>
      )}
      <i className="fa fa-map-marker"></i> {lead.city}
      {lead.district && <> {lead.district}, </>}
      {lead.state}
      <br />
      {lead.country_name && (
        <>
          {lead.country_name}
          <br />
        </>
      )}
      {lead.pin_code && (
        <>
          <i className="fa fa-map-pin"></i> {lead.pin_code}
        </>
      )}
    </>
  )

  const renderLeadTypeBadges = () => {
    const badgeTypes = {
      "high priority": { color: "green", text: "High Priority" },
      followup: { color: "orange", text: "Followup" },
      new: { color: "#58a0c3", text: "New" },
      matured: { color: "green", text: "Matured" },
      dead: { color: "red", text: "Dead" },
      repeated: { color: "purple", text: "Repeated" },
      "transfer request": { color: "pink", text: "Transfer Request" },
      dead_request: { color: "purple", text: "Dead Request" },
      "company pool": { color: "blue", text: "Company Pool" },
      matured_dead: { color: "#D6BD42", text: "Matured Dead" },
      matured_dead_request: { color: "purple", text: "Matured Dead Request" },
    }

    return (
      <>
        {lead.type?.map((item, i) => (
          <div key={i}>
            <br />
            {badgeTypes[item] && (
              <span
                className="badge"
                style={{ backgroundColor: badgeTypes[item].color }}
              >
                {badgeTypes[item].text}
              </span>
            )}
          </div>
        ))}
        {lead.deleted_at && (
          <>
            <br />
            <span className="badge" style={{ backgroundColor: "red" }}>
              Trash
            </span>
          </>
        )}
        <br />
        <span className="badge" style={{ backgroundColor: "#f39c12" }}>
          {lead.dead_status}
        </span>
        <br />
        <span className="badge" style={{ backgroundColor: "#045fcf" }}>
          {lead.followup_status}
        </span>
        <br />
        <span className="badge" style={{ backgroundColor: "green" }}>
          {lead.mature_status}
        </span>
      </>
    )
  }

  const getTableRowClass = () => {
    if (lead?.is_updated_after_transfer === 0) return "table-secondary"
    if (lead.type?.includes("dead") || lead.deleted_at) return "table-danger"
    if (lead.type?.includes("followup")) return "table-warning"
    if (lead.type?.includes("matured")) return "table-success"
    if (lead.type?.includes("new")) return "table-info"
    return ""
  }

  if (lead === "") {
    return ""
  } else
    return (
      <>
        {modal_standard ? (
          <EditLeadModal
            modal_standard={modal_standard}
            setmodal_standard={setmodal_standard}
            lead={lead}
            loader3={loader3}
            setLoader3={setLoader3}
            setLead={updateLeadAndStorage}
            setIsOpen={setIsOpen}
            module="lead"
          />
        ) : null}
        {isOpen2 ? (
          <ReminderModal
            modal_reminder={modal_reminder}
            setmodal_reminder={setmodal_reminder}
            lead={lead.id}
            setLead={updateLeadAndStorage}
            setIsOpen2={setIsOpen2}
          />
        ) : null}
        {modal ? (
          <CreateFollowup
            modal={modal}
            setModal={setModal}
            lead={lead}
            setLead={updateLeadAndStorage}
            customActiveTab={followupActiveTab}
            getAllLeads={props.getAllLeads}
          />
        ) : null}
        {message_alert ? (
          <SweetAlert
            confirmButtonText="Ok"
            cancelBtnBsStyle="danger"
            onConfirm={() => {
              setmessage_alert(false)
            }}
          >
            <h4 className="text-center fst-italic">
              {lead.leadholder_name} is already in touch with this lead. If you
              want to follow this lead, please contact your admin.
            </h4>
          </SweetAlert>
        ) : null}
        {props.global && lead.can_edit_lead === null ? (
          ""
        ) : (
          <tr key={props.i} className={getTableRowClass()}>
            <td>
              <input
                onChange={e => getSelectedId(lead.id, e)}
                name="chk"
                value={lead.id}
                className="p-0 d-inline-block"
                type="checkbox"
              />
            </td>
            <td>{props.counter + props.i}</td>
            <td>
              <div ref={setTriggerRef}>
                {!isTeamLeaderViewingOtherLead() && (
                  <>
                    {localStorage.getItem("company_name") !== "medallion" &&
                      visible && (
                        <div
                          ref={setTooltipRef}
                          {...getTooltipProps({
                            className: "tooltip-container",
                          })}
                        >
                          <span>
                            <a href={`tel:${getCountryCode()}${lead.number}`}>
                              <i className="fa fa-mobile"></i>{" "}
                              {getCountryCode()} {lead.number}
                            </a>
                          </span>
                          {lead.alternate_number && (
                            <span>
                              {" "}
                              <i className="fa fa-mobile"></i>{" "}
                              {lead.alternate_number}
                            </span>
                          )}
                          <span>
                            <i className="fa fa-envelope"></i> {lead.email}
                          </span>
                          <span>
                            <i className="fa fa-map-marker"></i> {lead.city}{" "}
                            {lead.district}
                          </span>
                          <span>{lead.state}</span>
                          <span>{lead.country_name}</span>
                          <span>{lead.pin_code}</span>
                          <div
                            {...getArrowProps({
                              className: "tooltip-arrow",
                            })}
                          />
                        </div>
                      )}
                  </>
                )}
                {lead.firm_name && <span>({lead.firm_name})</span>}
                <br />
                {lead.can_edit_lead ? (
                  <>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        getProfileData(lead.id)
                        setCustomActiveTab(1)
                      }}
                      className="text-info fs-5"
                    >
                      {lead.name}
                    </span>
                    <a
                      style={{ cursor: "pointer", color: "#08913b" }}
                      target="_blank"
                      href={sendWhatsAppMessage(lead.number)}
                    >
                      <i className="fab fa-whatsapp ms-2 fa-lg"></i>
                    </a>
                  </>
                ) : (
                  <span className="text-info fs-5">{lead.name}</span>
                )}
                <br />
              </div>
              {lead.can_edit_lead && (
                <>
                  {!(
                    getCurrentUser().crm_permission == 0 &&
                    getCurrentUser().crmpro_permission == 0 &&
                    lead.type?.includes("matured")
                  ) &&
                    (loader ? (
                      <span className="sweet-loading">
                        <ClipLoader />
                      </span>
                    ) : (
                      <span
                        className="btn badge bg-success"
                        onClick={() => {
                          getProfileData(lead.id)
                          setCustomActiveTab(2)
                          setLoader(true)
                        }}
                      >
                        Update Status
                      </span>
                    ))}
                  <br />
                  {loader3 ? (
                    <span className="btn badge bg-primary sweet-loading">
                      <ClipLoader />
                    </span>
                  ) : (
                    <span
                      className="btn badge bg-primary"
                      onClick={() => {
                        const editHandler =
                          lead.type?.includes("matured") &&
                          getCurrentUser().role_name !== "Administrator"
                            ? editLead
                            : editLead
                        editHandler(lead.id)
                        setLoader3(true)
                      }}
                    >
                      Edit Info
                    </span>
                  )}
                  <br />
                  {localStorage.getItem("company_name") === "demo" && (
                    <>
                      <span
                        className="btn badge bg-purple"
                        onClick={() => updateReminder(lead.id)}
                      >
                        Set Reminder
                      </span>
                      <br />
                    </>
                  )}
                </>
              )}
              {lead.flag === "1" && <i className="fa fa-star"></i>}
              <br />
              {lead.created_at}
              <br />
              <span className="fw-bold">ID- </span>
              {lead.id}
            </td>
            {getCurrentUser().role_name === "Administrator" ? (
              <td>{renderContactInfo(true)}</td>
            ) : (
              <td>{renderContactInfo(false)}</td>
            )}
            <td>{lead.lead_source}</td>
            {getCurrentUser()?.enable_branch === 1 && (
              <td>{lead?.branch?.name}</td>
            )}
            {getCurrentUser()?.tag === 1 && <td>{lead.tag_name}</td>}
            <td>
              {lead.lead_label?.map((item, i) => (
                <div key={i}>
                  <span
                    className="badge"
                    style={{ backgroundColor: "#f39c12" }}
                  >
                    {item.name}
                  </span>{" "}
                  <br />
                </div>
              ))}
            </td>
            {getCurrentUser().role_name !== "Executive" && (
              <td>
                <img
                  style={{
                    height: "40px",
                    width: "40px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  src={lead.leadholder_photo}
                  alt="Lead holder"
                />
                <br />
                {lead.leadholder_name}
                <br />
              </td>
            )}
            <td>{renderLeadTypeBadges()}</td>
            {localStorage.getItem("ShowImportant") ? (
              <td>{lead?.important_date}</td>
            ) : null}
            <td>
              {(lead.type && lead.type.includes("dead")) ||
              (lead.type && lead.type.includes("dead_request")) ? (
                ""
              ) : (
                <>
                  {lead.next_followup_date}
                  <br />
                  {lead.next_followup_time}
                  {getCurrentUser().role_name == "Executive" ? (
                    ""
                  ) : (
                    <>
                      <hr />
                      {lead.followup_counter === 0 ? (
                        ""
                      ) : (
                        <span>{lead.followup_counter} followup</span>
                      )}
                    </>
                  )}
                  <br />
                  {lead.mature_status_options === "reorder"
                    ? "Reorder"
                    : lead.mature_status_options === "payment_reminder"
                    ? "Payment Reminder"
                    : ""}
                </>
              )}
            </td>
            <td>
              <LongText content={lead.last_message} />
              <br />
              {lead.last_followup_date}
              <br />
              {lead.update_by}
              <br />
              {lead.can_edit_lead ? (
                <>
                  {getCurrentUser().crm_permission == 0 &&
                  getCurrentUser().crmpro_permission == 0 &&
                  lead.type.includes("matured") ? (
                    <span
                      className="btn badge bg-primary"
                      onClick={e => {
                        getProfileData(lead.id),
                          setCustomActiveTab(3),
                          setHistoryTab(true)
                      }}
                    >
                      Lead History
                    </span>
                  ) : (
                    <span
                      className="btn badge bg-primary"
                      onClick={e => {
                        getProfileData(lead.id),
                          setCustomActiveTab(3),
                          setHistoryTab(true)
                      }}
                    >
                      Lead History
                    </span>
                  )}
                </>
              ) : (
                ""
              )}
            </td>
            <td>
              {lead.can_edit_lead ? (
                <>
                  {lead.type && lead.type.includes("matured") ? (
                    getCurrentUser().role_name === "Administrator" ? (
                      <a
                        className="text-warning"
                        onClick={() => {
                          editLead(lead.id)
                        }}
                      >
                        <i className="fas fa-pen" />
                      </a>
                    ) : (
                      <a
                        className="text-warning"
                        onClick={() => {
                          editLead2(lead.id)
                        }}
                      >
                        <i className="fas fa-pen" />
                      </a>
                    )
                  ) : (
                    <a
                      className="text-warning"
                      onClick={() => {
                        editLead(lead.id)
                      }}
                    >
                      <i className="fas fa-pen" />
                    </a>
                  )}
                </>
              ) : (
                ""
              )}
              {getPermission().lead.lead.delete.is_checked === "yes" ? (
                <>
                  {lead.type && lead.type.includes("matured") ? (
                    ""
                  ) : (
                    <a
                      className="text-danger ms-2"
                      onClick={() => {
                        setconfirm_alert(true)
                      }}
                    >
                      <i className="fas fa-trash-alt" />
                    </a>
                  )}
                </>
              ) : (
                ""
              )}
              {confirm_alert ? (
                <SweetAlert
                  title="Are you sure?"
                  warning
                  showCancel
                  confirmButtonText="Yes, delete it!"
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => {
                    setconfirm_alert(false)
                    setsuccess_dlg(true)
                    deleteLead(lead.id)
                    setdynamic_title("Deleted")
                    setdynamic_description("Your file has been deleted.")
                  }}
                  onCancel={() => setconfirm_alert(false)}
                >
                  <input
                    onChange={() => setCheck(1)}
                    type="checkbox"
                    name="is_deleted"
                  />
                  {"  "}
                  <span className="text-danger">
                    Delete it from server as well?
                  </span>
                  <br />
                  <span className="text-normal">
                    It will be automatically deleted after 7 days.
                  </span>
                </SweetAlert>
              ) : null}
            </td>
          </tr>
        )}
        <Modal isOpen={modal_xl} centered={true} size="xl">
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myLargeModalLabel">
              {profileData.name}'s Profile
            </h5>
            <button
              type="button"
              className="cross__btn"
              onClick={() => setmodal_xl(false)}
              aria-hidden="true"
            >
              &times;
            </button>
          </div>
          <div className="modal-body">
            {showInfo ? (
              <Row
                className="m-0 p-3"
                style={{
                  background: "#efefef",
                }}
              >
                <Col md={lead.type && lead.type.includes("matured") ? 4 : 8}>
                  <span>
                    {lead?.firm_name && (
                      <>
                        <span>
                          <span className="fw-bold">Firm name:</span>{" "}
                          {lead.firm_name}
                        </span>
                        <br />
                      </>
                    )}
                  </span>
                  <span>
                    <span className="fw-bold">Email: </span>
                    <a
                      className="text-info"
                      target="_blank"
                      href={`mailto:${lead.email}`}
                    >
                      {getCurrentUser().role_name == "Team Leader" &&
                      getCurrentUser().name !== lead.leadholder_name ? (
                        <>***********.gmail.com</>
                      ) : (
                        <>{lead.email}</>
                      )}
                    </a>
                  </span>{" "}
                  <br />
                  <span>
                    <span className="fw-bold">Lead Source:</span>{" "}
                    <b>{lead.lead_source}</b>
                  </span>
                  <br />
                  <span>
                    <span className="fw-bold">Lead Label:</span>
                    {lead.lead_label &&
                      lead.lead_label.map((item, i) => (
                        <>
                          <span
                            key={i}
                            className="badge"
                            style={{ backgroundColor: "#f39c12" }}
                          >
                            {item.name}
                          </span>{" "}
                        </>
                      ))}
                  </span>
                  <br />
                  <span>
                    <span className="fw-bold">Phone:</span>{" "}
                    {lead.country_code || "+91"}{" "}
                    <a
                      className="text-info"
                      href={`tel://+91${lead.number}`}
                      target="_blank"
                    >
                      {getCurrentUser().role_name == "Team Leader" &&
                      getCurrentUser().name !== lead.leadholder_name ? (
                        <>**********</>
                      ) : (
                        <>{lead.number}</>
                      )}
                    </a>
                  </span>{" "}
                  <a
                    style={{ cursor: "pointer", color: "#08913b" }}
                    target="_blank"
                    rel="noreferrer"
                    href={sendWhatsAppMessage(lead.number)}
                    title="Open Web WhatsApp"
                  >
                    <i className="fab fa-whatsapp ms-2 fa-lg"></i>
                  </a>{" "}
                  {metaWhatsappEnabled ? (
                    <button
                      type="button"
                      className="btn btn-sm btn-success ms-2"
                      onClick={() => setMetaWaModal(true)}
                      title="Send via Meta WhatsApp Cloud API"
                    >
                      Send WhatsApp
                    </button>
                  ) : null}
                  <br />
                  <span>
                    <span className="fw-bold">Location:</span>{" "}
                    {lead.city && <>{lead.city}, </>}
                    {lead.district && <>{lead.district}, </>}
                    {lead.state && <>{lead.state}, </>}
                    {lead.country}
                  </span>{" "}
                  <br />
                  <span>
                    {lead.pin_code && (
                      <>
                        <span className="fw-bold">PIN:</span> {lead.pin_code}
                      </>
                    )}
                  </span>
                </Col>
                <Col md={lead.type && lead.type.includes("matured") ? 5 : 4}>
                  {lead.matured_date && (
                    <>
                      <span>
                        <span className="fw-bold">Customer Since:</span>{" "}
                        {lead.matured_date}
                      </span>
                      <br />
                      <span className="fw-bold">Products Ordered:</span>
                      <br />
                      <LongText content={lead?.products} />
                    </>
                  )}
                  <br />
                  <span>
                    <span className="fw-bold">Last Updated:</span>{" "}
                    {lead.updated_at}
                  </span>
                  <br />
                  <span>
                    <span className="fw-bold">Alternate Number:</span>{" "}
                    {lead.alternate_number && (
                      <>
                        {lead.country_code ? ` +${lead.country_code}` : "+91"}{" "}
                        <a
                          className="text-info"
                          href={`tel://+91${lead.alternate_number}`}
                          target="_blank"
                        >
                          {isTeamLeaderViewingOtherLead() ? (
                            <>**********</>
                          ) : (
                            <>{lead.alternate_number}</>
                          )}
                        </a>
                        <a
                          style={{ cursor: "pointer", color: "#08913b" }}
                          target="_blank"
                          href={sendWhatsAppMessage(lead.alternate_number)}
                        >
                          <i className="fab fa-whatsapp ms-2 fa-lg"></i>
                        </a>{" "}
                        <a
                          style={{ cursor: "pointer", color: "#08913b" }}
                          target="_blank"
                          href={sendWhatsAppMessage(lead.alternate_number)}
                        >
                          <i className="fab fa-whatsapp ms-2 fa-lg"></i>
                        </a>{" "}
                      </>
                    )}
                  </span>{" "}
                </Col>
                {lead.type && lead.type.includes("matured") ? (
                  <Col md={3}>
                    <span className="fw-bold d-flex justify-content-center">
                      Business Done/Target
                    </span>
                    <div className="p-2" style={{ border: "gray solid 2px" }}>
                      <span>
                        <span className="fw-bold">Monthly: </span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: lead.monthly_bussiness_target,
                          }}
                        />
                      </span>{" "}
                      <br />
                      <span>
                        <span className="fw-bold">Last 3 Months: </span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: lead.three_months_bussiness,
                          }}
                        />
                      </span>{" "}
                      <br />
                      <span>
                        <span className="fw-bold">Overall: </span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: lead.overall_bussiness_target,
                          }}
                        />
                      </span>
                    </div>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            ) : (
              ""
            )}
            <Nav
              tabs
              style={{
                justifyContent: "center",
                background: "#efefef",
              }}
            >
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowInfo(!showInfo)
                  }}
                >
                  {" "}
                  {showInfo ? (
                    <i className="fa fa-arrow-up me-2"></i>
                  ) : (
                    <i className="fa fa-arrow-down me-2"></i>
                  )}
                  Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: customActiveTab === 1 })}
                  onClick={() => {
                    toggleCustom(1)
                  }}
                >
                  {" "}
                  Profile
                </NavLink>
              </NavItem>
              <NavItem>
                {getCurrentUser().crm_permission == 0 &&
                getCurrentUser().crmpro_permission == 0 &&
                lead.type.includes("matured") ? (
                  <NavLink
                    style={{ pointerEvents: "none", opacity: "0.25" }}
                    className={classnames({ active: customActiveTab === 2 })}
                    onClick={() => {
                      toggleCustom(2)
                    }}
                  >
                    {" "}
                    Update Here
                  </NavLink>
                ) : (
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: customActiveTab === 2 })}
                    onClick={() => {
                      toggleCustom(2)
                    }}
                  >
                    {" "}
                    Update Here
                  </NavLink>
                )}
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: customActiveTab === 3 })}
                  onClick={() => {
                    toggleCustom(3)
                  }}
                >
                  {" "}
                  Lead History
                </NavLink>
              </NavItem>
              {getCurrentUser().crmpro_products_enabled == 1 ? (
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: customActiveTab === 4 })}
                    onClick={() => {
                      toggleCustom(4)
                    }}
                  >
                    {" "}
                    Products
                  </NavLink>
                </NavItem>
              ) : (
                ""
              )}
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: customActiveTab === 5 })}
                  onClick={() => {
                    toggleCustom(5)
                  }}
                >
                  {" "}
                  Proforma
                </NavLink>
              </NavItem>
              {lead.type?.includes("matured") ? (
                <>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === 6,
                      })}
                      onClick={() => {
                        toggleCustom(6)
                      }}
                    >
                      {" "}
                      Order History
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === 8,
                      })}
                      onClick={() => {
                        toggleCustom(8)
                      }}
                    >
                      {" "}
                      Ledger/Payments
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === 9,
                      })}
                      onClick={() => {
                        toggleCustom(9)
                      }}
                    >
                      {" "}
                      Scheme
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === 10,
                      })}
                      onClick={() => {
                        toggleCustom(10)
                      }}
                    >
                      {" "}
                      Complaints
                    </NavLink>
                  </NavItem>
                </>
              ) : (
                ""
              )}
              {getCurrentUser().crmpro_permission == 1 ||
              getCurrentUser().crmpronew_permission == 1 ? (
                <></>
              ) : (
                <></>
              )}
            </Nav>
            <TabContent activeTab={customActiveTab} className="pt-3">
              <TabPane tabId={1}>
                <>
                  <CprofileTable profileData={profileData} leadId={lead.id} />
                </>
              </TabPane>
              <TabPane tabId={2}>
                <>
                  {updateTab ? (
                    <CupdateTable
                      typeMature={typeMature}
                      setmodal_xl={setmodal_xl}
                      getAllLeads={props.getAllLeads}
                      lead={lead}
                    />
                  ) : (
                    ""
                  )}
                </>
              </TabPane>
              <TabPane tabId={3}>
                <>
                  {historyTab ? (
                    <ChistoryTable historyData={historyData} leadId={lead.id} />
                  ) : (
                    ""
                  )}
                </>
              </TabPane>
              <TabPane tabId={4}>
                <>{productTab ? <CproductTable leadId={lead.id} /> : ""}</>
              </TabPane>
              <TabPane tabId={5}>
                <>{proformaTab ? <CproformaTable leadId={lead.id} /> : ""}</>
              </TabPane>
              <TabPane tabId={6}>
                <>{orderTab ? <CorderTable leadId={lead.id} /> : ""}</>
              </TabPane>
              <TabPane tabId={7}>
                <>
                  {quotationsTab ? <CQuotationsTable leadId={lead.id} /> : ""}
                </>
              </TabPane>
              <TabPane tabId={8}>
                <>{ledgerTab ? <CledgerTable leadId={lead.id} /> : ""}</>
              </TabPane>
              <TabPane tabId={9}>
                <>{schemeTab ? <CschemeTable leadId={lead.id} /> : ""}</>
              </TabPane>
              <TabPane tabId={10}>
                <>{complaintTab ? <CcomplaintTable leadId={lead.id} /> : ""}</>
              </TabPane>
            </TabContent>
          </div>
        </Modal>
        {metaWhatsappEnabled ? (
          <MetaWhatsAppSendModal
            isOpen={metaWaModal}
            toggle={() => setMetaWaModal(false)}
            leadName={lead?.name || profileData?.name}
            leadNumber={lead?.number}
            countryCode={lead?.country_code}
          />
        ) : null}
      </>
    )
}
export default LeadList
